import BreadCrumbs from 'components/breadcrumbs'
import CustomButton from 'components/Buttons/CustomButton'
import { setSessionProcess } from 'features/public-views/login/loginSlice'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { UserPlus } from 'react-feather'
// import QrReader from 'react-qr-reader'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  Button,
  Card,
  CardBody,
  Container,
  FormGroup,
  Input,
  Label,
} from 'reactstrap'
import { URL_PROCESS, URL_SESSION_PROCESS } from 'utils/pathUrl'
import { useAddEditSessionMutation } from '../processApiSlice'

const JoinSession = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()

  const [mode, setMode] = useState('manual') // manual | qr
  const [payload, setPayload] = useState({ sessionId: '', role: '' })
  const [cameraFacing, setCameraFacing] = useState('environment') // environment | user
  const [addOrEditSession] = useAddEditSessionMutation()

  const handleSubmit = async () => {
    try {
      const res = await addOrEditSession(payload)
      if (res?.error) throw res
      dispatch(setSessionProcess(res?.data))
      navigate(URL_PROCESS, { state: res })
    } catch (error) {
      enqueueSnackbar(error?.message ?? error?.error?.data?.message, {
        variant: 'error',
      })
    }
  }

  const handleScan = (data) => {
    if (data) {
      setPayload((prev) => ({ ...prev, sessionId: data }))
      enqueueSnackbar('Kode QR berhasil dipindai!', { variant: 'success' })
    }
  }

  const handleError = (err) => {
    console.error('QR Reader Error:', err)
    enqueueSnackbar('Gagal mengakses kamera', { variant: 'error' })
  }

  const toggleCamera = () => {
    setCameraFacing((prev) => (prev === 'environment' ? 'user' : 'environment'))
    enqueueSnackbar('Kamera diganti', { variant: 'info' })
  }

  return (
    <div className="w-100 px-3 pb-3">
      <Container className="custom-container">
        {/* Breadcrumb */}
        <div className="pt-3">
          <BreadCrumbs breadCrumbActive={'Gabung Sesi Produksi'} />
        </div>

        {/* Kartu utama */}
        <Card className="shadow-sm rounded-3 border-0">
          <CardBody className="text-center p-4">
            {/* Header */}
            <div className="mb-3">
              <UserPlus size={42} className="text-primary mb-2" />
              <h5 className="fw-bold mb-1">Gabung Sesi Produksi</h5>
              <p className="text-muted mb-4">
                Masukkan ID sesi yang aktif untuk berkolaborasi
              </p>
            </div>

            {/* Tab Manual / QR */}
            <div className="d-flex justify-content-center mb-4">
              <Button
                color="light"
                className={`w-50 fw-semibold ${
                  mode === 'manual' ? 'border-primary text-primary' : ''
                }`}
                onClick={() => setMode('manual')}
                data-testid="process-join-manual-tab"
              >
                <i className="bi bi-keyboard me-1"></i> Manual
              </Button>
              <Button
                color="light"
                className={`w-50 fw-semibold ${
                  mode === 'qr' ? 'border-primary text-primary' : ''
                }`}
                onClick={() => setMode('qr')}
                data-testid="process-join-qr-tab"
              >
                <i className="bi bi-qr-code-scan me-1"></i> Pindai QR
              </Button>
            </div>

            {/* Mode Manual */}
            {mode === 'manual' && (
              <div className="text-start">
                <FormGroup className="mb-3">
                  <Label className="fw-semibold">ID Sesi</Label>
                  <Input
                    type="text"
                    placeholder="contoh: SES-20241106-1430"
                    value={payload.sessionId}
                    onChange={(e) =>
                      setPayload({ ...payload, sessionId: e.target.value })
                    }
                    data-testid="process-join-session-id-input"
                  />
                </FormGroup>

                <FormGroup className="mb-3">
                  <Label className="fw-semibold">
                    Stasiun / Peran (Opsional)
                  </Label>
                  <Input
                    type="text"
                    placeholder="contoh: Input, Fillet, Packaging"
                    value={payload.role}
                    onChange={(e) =>
                      setPayload({ ...payload, role: e.target.value })
                    }
                    data-testid="process-join-role-input"
                  />
                  <small className="text-muted">
                    Tentukan stasiun Anda untuk pelacakan yang lebih baik.
                  </small>
                </FormGroup>
              </div>
            )}

            {/* Mode QR */}
            {mode === 'qr' && (
              <div className="d-flex flex-column align-items-center">
                <div
                  className="border rounded-3 mb-3 d-flex justify-content-center align-items-center bg-light"
                  style={{
                    width: 260,
                    height: 260,
                    overflow: 'hidden',
                    position: 'relative',
                  }}
                >
                  {/* <QrReader
                    key={cameraFacing}
                    delay={300}
                    onError={handleError}
                    onScan={handleScan}
                    style={{ width: '100%' }}
                    facingMode={cameraFacing}
                    onLoad={() => {}}
                    className="rounded-3 overflow-hidden"
                  /> */}
                </div>
                <p className="text-muted mb-0">Arahkan kamera ke kode QR</p>
                <Button
                  size="sm"
                  color="secondary"
                  outline
                  className="mt-2"
                  onClick={toggleCamera}
                >
                  Ganti Kamera
                </Button>
              </div>
            )}

            {/* Tombol Aksi */}
            <CustomButton
              onClick={handleSubmit}
              color="primary"
              disabled={!payload.sessionId}
              className="mt-4 w-100"
              block
              testId="process-join-submit-button"
            >
              <UserPlus size={16} className="me-1" />
              Gabung ke Sesi
            </CustomButton>

            <CustomButton
              onClick={() => navigate(URL_SESSION_PROCESS)}
              color="primary"
              outline
              className="mt-2 w-100"
              block
            >
              Kembali
            </CustomButton>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}

export default JoinSession
